import Button from '@/components/Button'
import { MULT_URL } from '@/const'
import { useCurrentUser, usePage } from '@/hooks'
import {
  asideLogo,
  userIcon,
  cameraIcon,
  playIcon,
  gameIcon,
  trophyIcon,
  closeIcon
} from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import style from '../styles/layout.module.scss'
import Navigation from './navigation'

const Header = (): React.ReactElement => {
  const [openedHeader, setOpenedHeader] = useState(false)
  const { isLoaded, isLogin, currentUser } = useCurrentUser()

  const page = usePage()
  const { config } = page.init_state.global

  const toggleOpenedHeader = (): void => {
    setOpenedHeader(!openedHeader)
  }

  const handleCloseHeader = (): void => {
    setOpenedHeader(false)
  }

  useEffect(() => {
    if (openedHeader) {
      document.body.classList.add('scroll_lock')
    } else {
      document.body.classList.remove('scroll_lock')
    }
  }, [openedHeader])

  return (
    <>
      <header
        className={classNames({
          [style.header]: true,
          [style['header--opened']]: openedHeader
        })}
      >
        <button
          type='button'
          className={style.header__back}
          onClick={handleCloseHeader}
        >
          <GxIcon src={closeIcon} className={style.header__back_icon} />
        </button>
        <Link to='/' className={style.header__logo_link}>
          <div className={style.header__logo_wrap}>
            <img
              src={asideLogo}
              width='330px'
              height='152px'
              alt='Логотип'
              className={style.header__logo}
            />
          </div>
        </Link>
        <div className={style.header_content}>
          {!isLoaded ? <div className={style.user__sceleton} /> : undefined}
          {isLoaded && !isLogin
            ? (
              <Button
                wide
                size='extralarge'
                highlight
                href={config?.authorization}
                onClick={handleCloseHeader}
                className={style.header__login}
              >
                <GxIcon src={userIcon} slot='icon-left' />
                Вход/Регистрация
              </Button>
              )
            : null}
          {isLoaded && isLogin
            ? (
              <Link to={config?.profile ?? ''} onClick={handleCloseHeader} className={style.user}>
                {currentUser?.personal_photo !== null
                  ? (
                    <img
                      src={currentUser.personal_photo}
                      width='60px'
                      height='60px'
                      alt='Аватар'
                      className={style.user__photo}
                    />
                    )
                  : (
                    <div className={style.user__emptyava_wrap}>
                      <GxIcon src={userIcon} className={style.user__emptyava} />
                    </div>
                    )}
                <span className={style.user__name}>{currentUser.name}</span>
              </Link>
              )
            : null}
          <Navigation handleCloseHeader={handleCloseHeader} />
        </div>

        <a
          className={`${style.header__mult} highlight`}
          href={MULT_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          <GxIcon
            src={cameraIcon}
            slot='icon-left'
            className={style.header__mult_icon}
          />
          Жэка-мульт
        </a>
      </header>

      <ul className={style.mobmenu}>
        <li className={style.mobmenu__item}>
          <NavLink
            to={config?.home_url ?? ''}
            className={({ isActive }) =>
              `${style.mobmenu__link} ${
                isActive ? style['mobmenu__link--active'] : ''
              }`}
          >
            <GxIcon src={playIcon} className={style.mobmenu__icon} />
          </NavLink>
        </li>
        <li className={style.mobmenu__item}>
          <NavLink
            to={config?.games ?? ''}
            className={({ isActive }) =>
              `${style.mobmenu__link} ${
                isActive ? style['mobmenu__link--active'] : ''
              }`}
          >
            <GxIcon src={gameIcon} className={style.mobmenu__icon} />
          </NavLink>
        </li>
        <li className={style.mobmenu__item}>
          <button
            type='button'
            className={style.mobmenu__button}
            onClick={toggleOpenedHeader}
          >
            Меню
          </button>
        </li>
        <li className={style.mobmenu__item}>
          <NavLink
            to={config?.championships ?? ''}
            className={({ isActive }) =>
              `${style.mobmenu__link} ${
                isActive ? style['mobmenu__link--active'] : ''
              }`}
          >
            <GxIcon src={trophyIcon} className={style.mobmenu__icon} />
          </NavLink>
        </li>
        <li className={style.mobmenu__item}>
          {isLoaded && !isLogin
            ? (
              <NavLink
                to={config?.authorization ?? ''}
                className={({ isActive }) =>
                `${style.mobmenu__link} ${
                  isActive ? style['mobmenu__link--active'] : ''
                }`}
              >
                <GxIcon src={userIcon} className={style.mobmenu__icon} />
              </NavLink>
              )
            : (
              <NavLink
                to={config?.profile ?? ''}
                className={({ isActive }) =>
                `${style.mobmenu__link} ${
                  isActive ? style['mobmenu__link--active'] : ''
                }`}
              >
                {currentUser?.personal_photo !== null
                  ? (
                    <img
                      src={currentUser?.personal_photo}
                      width='30px'
                      height='30px'
                      alt=''
                      className={style.mobmenu__ava}
                    />
                    )
                  : (
                    <GxIcon src={userIcon} className={style.mobmenu__icon} />
                    )}
              </NavLink>
              )}
        </li>
      </ul>
    </>
  )
}

export default Header
